export * from './FiltroClasseSocial'